import React, {useState} from 'react';
import AutoCompleteWithScroll from "../autocompletewithscroll/AutoCompleteWithScroll";
import {Box, Button} from "@mui/material";
import {startingWiewButton} from "../startingwiew/constants/constants";
import fetchRequest from "../../queries/fetchRequest";
import {MultiDirectedGraph} from "graphology";

const styles = {
  tableViewStyle: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
    justifyContent: "start",
    height: "100%",
    borderRadius: "10px",
    margin: "10px",
    marginLeft: "20px",
    marginTop: "20px"
  },
  buttonStyle: {

  }
}

const NameInput = (
  {
    setIsKeywordsLoading,
    filterValues,
    nameArray,
    setNameArray,
    setNameQueryAnswer,
    setGraph,
    setQueryButtonPressed,
    setMapAnswer,
    setIsLoading,
    isTableView,
    setNameKeywordQueryAnswer
  }) => {
  const [selectedName, setSelectedName] = useState([]);
  const [selectedNameCode, setSelectedNameCode] = useState([]);

  const callNameQuery = async() => {
    setIsLoading(true);
    setIsKeywordsLoading(true);
    const names = selectedName.map(name => name.nimetus);
    const codes = selectedName.map(name => name.kood);
    setNameArray(names);
    const namesTextCodesResult = await fetchRequest({tekst: names, minYear: filterValues.dateMin, maxYear: filterValues.dateMax}, "gettextcodesbynamecopy");
    console.log(namesTextCodesResult)
    if(namesTextCodesResult !== "No rows") {
      const props = {
        dateMin: 2000,
        dateMax: 2023,
        sortBy: "kokku",
        sortOrder: "DESC",
        page: 1,
        nimi: names,
        limit: 10000000000,
        tekst: namesTextCodesResult,
        codes: codes
      }
      const queryRes = await fetchRequest(props, "getnimednimedestcopy");
      setNameQueryAnswer(queryRes)
      setQueryButtonPressed("name");
      setGraph(new MultiDirectedGraph())
      const filteredQuery = queryRes.filter((val) => val.tyyp === 'loc');
      setIsLoading(false);

      const mapResponse = await fetchRequest({places: filteredQuery.map(value => value.olemi_kood)}, "getmapdatacopy");
      const mergedArray = filteredQuery.map(obj1 => {
        const obj2 = mapResponse.find(obj => obj.olemi_kood === obj1.olemi_kood);
        return { ...obj1, ...obj2 };
      }).filter(obj => 'laiuskraad' in obj && 'pikkuskraad' in obj);
      setMapAnswer(mergedArray);

      const keywordResponse = await fetchRequest({codes: namesTextCodesResult}, "getmarksonadnimedestcopy");
      setNameKeywordQueryAnswer(keywordResponse)
      setIsKeywordsLoading(false);
    }
  }

  return (
    <Box sx={isTableView && styles.tableViewStyle}>
      {!isTableView && <div className="starting-view-text">Nimed: </div>}
      <AutoCompleteWithScroll
        isTableView={isTableView}
        nameArray={nameArray}
        setNimeData={setSelectedName}
        nimeData={selectedName}
        selectedNameCode={selectedNameCode}
        setSelectedNameCode={setSelectedNameCode}
      />
      <Button
        disabled={!selectedName[0]}
        sx={isTableView ? styles.buttonStyle : startingWiewButton}
        onClick={callNameQuery}
        variant={"contained"}
      >
        Saada päring
      </Button>
    </Box>
  );
};

export default NameInput;